import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import main_bg from '../../Images/main_bg.png';
import main_bg2 from '../../Images/main_bg2.png';
import main_joystick_img from '../../Images/main_joystick_img.png';

import BasicButton from '../../Components/Button/BasicButton';
import Video from '../../Video/video.mp4'

const Container = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  height: 1350px;
  overflow: hidden;
  & > video {
    position: absolute;
    top: 0;
    left: auto;
    height: 1330px;
    opacity: 0.3;
  }
`
const BgImg = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  width: 100%;

  & > img {
    width: 4000px;
    /* margin-top: -400px; */
  }
`
const MainBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 100;
  width: 1370px;
  padding: 0 40px;

  & > iframe {
    margin-top: 280px;
  }

  @media (max-width: 1410px) {
    width: 100%;
    padding: 0 20px;
    flex-direction: column;
    align-items: center;

    & > iframe {
      padding-left: 2.5%;
      margin-top: 40px;
    }
  };
  @media (max-width: 560px) {
    & > img {
      width: 100%;
    }
  };
`
const TextBox = styled.div`
  position: relative;
  margin-top: 385px;
  & > h2 {
    position: relative;
    width: 800px;
    text-align: left;
    font-weight: 400;
    font-size: 64px;
    letter-spacing: 0.05em;
    line-height: 140%;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    color: white;
    z-index: 10;
  }
  & > h2:nth-child(2) {
    position: absolute;
    top: 4px;
    left: 4px;
    -webkit-text-stroke: 1px #FF8E00;
    color: transparent;
    z-index: 0;
  }
  @media (max-width: 1410px) {
    margin-top: 280px;
    & > h2 {
      text-align: center;
    }
  };
  @media (max-width: 840px) {
    & > h2 {
      font-size: 54px;
      width: 100%;
      text-align: center;
    }
  };
`


const MainContainer = ({ language }) => {
  const iframeRef = useRef();

  useEffect(() => {
    window.addEventListener("resize", () => console.log(document.body.offsetWidth));
    return () => {
      window.removeEventListener("resize", () => console.log(document.body.offsetWidth));
    }
  })

  useEffect(() => {
    iframeRef.current.addEventListener("load", () => console.log('yes'));
    return () => {
      iframeRef.current.removeEventListener("load", () => console.log('no'));
    }
  })

  return (
    <Container id='HOME'>
      <BgImg>
        <img alt="" src={main_bg} />
      </BgImg>
      <video
        autoPlay
        loop
        muted={true}
        playbackRate={0.5}
        playsInline={true}
      >
        <source src={Video} type="video/mp4" />
      </video>
      <BgImg>
        <img alt="" src={main_bg2} />
      </BgImg>
      <MainBox>
        <TextBox>
          <h2>The Easiest Way to Make Blockchain Games FUN</h2>
          <h2>The Easiest Way to Make Blockchain Games FUN</h2>
        </TextBox>
        <iframe ref={iframeRef} src='https://my.spline.design/games-268b379c2b295ab460028320b8c3bd27/' frameborder='0' width='120%' height='30%'></iframe>

        {/* <BasicButton
          // href={language === "한국어" ? PaperKor : PaperEng }
          style={{ marginTop: 40 }}
          text={'White Paper'}
        /> */}
      </MainBox>
    </Container>
  );
};

export default MainContainer